import React from "react";
import { motion, Transition } from "framer-motion";

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

const transition: Transition = {
  duration: 0.2,
  ease: "easeOut",
};

const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  className,
}) => {
  return (
    <motion.div
      // initial={{ opacity: 0 }}
      // animate={{ opacity: 1 }}
      // exit={{ opacity: 0 }}
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.98 }}
      transition={transition}
      className={className}
      style={{ height: "100%", width: "100%" }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
